const Blur = ({ enable, children }) => (
	<div className={enable ? 'u-opacity-0-5 u-blur-3 u-pointer-events-none u-oa' : ''}>{children}</div>
);
export default Blur;
